<div class="modal-content">
  <form (submit)="onSubmit($event)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Deactivate Client</h4>
      <button type="button" class="btn-close" (click)="onCloseClick()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        Please give a short reason for this deactivation.
      </div>

      <input type="text" class="form-control mb-2" [formControl]="note" />

      @if (note.invalid && (note.dirty || note.touched) && note.errors?.present) {
        <div class="text-danger">Reason is required.</div>
      }

      @if (submitting) {
        <div class="m-2 d-flex justify-content-center">
          <mat-spinner [diameter]="28" />
        </div>
      }

      @if (errorMessage) {
        <div>
          <hr />
          <div class="alert alert-warning mt-2 mb-0">
            <fa-icon [icon]="['fas', 'exclamation-triangle']" class="warning me-2" />
            {{ errorMessage }}
          </div>
        </div>
      }

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" [disabled]="submitting || note.invalid">Deactivate</button>

        <button type="button" class="btn btn-secondary" [disabled]="submitting" (click)="onCloseClick()">Cancel</button>
      </div>

    </div>
  </form>
</div>
